import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import Bannerfooter from "../../../../../components/Bannerfooter/Bannerfooter";
import { Box, Button, CardActionArea, Container, Grid2 } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import useGlobalConfig from "../../../../../hooks/globalConfig";
import CountUp from "react-countup";
import { NavLink } from "react-router-dom";
import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "../../../../../firebase";

/* ======================
   Variantes de animación
   ====================== */
const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const slideLeft = {
  hidden: { opacity: 0, x: 40 },
  show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const slideRight = {
  hidden: { opacity: 0, x: -40 },
  show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const zoomIn = {
  hidden: { opacity: 0, scale: 0.96 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const staggerContainer = (delay = 0.12) => ({
  hidden: {},
  show: { transition: { staggerChildren: delay } },
});

const Pos5 = () => {
  const footermensaje = {
    className: "resaltadoCurvo FloatRignt marging20",
    title: "CIUDADES INTELIGENTES",
    paragramh:
      "La electromovilidad contribuye también al desarrollo de ciudades inteligentes o smart cities (en inglés), concepto que apunta al desarrollo urbano sostenible, dando respuesta a las necesidades de la sociedad, pero también de organizaciones y empresas, buscando la eficiencia energética y la reducción de emisiones de CO2, al mismo tiempo que el desarrollo económico y el cuidado del medioambiente.",
  };

  const {
    img1,
    img2,
    img3,
    img4,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    ecotribicci,
    homeImgUrl,
    biccidashboard,
    ecotribicci2,
    cobertura,
    btnvehicle,
    btnuseradmin,
    btnacuerdo,
    icomshome1,
    icomshome2,
    icomshome3,
    icomshome4,
    icomshome5,
  } = useGlobalConfig();

  const [totalDelivery, setTotalDelivery] = useState(36000);
  const [totalCal, setTotalCal] = useState(26000);
  const [clientsEstimat, setClientsEstimat] = useState(26000);

  useEffect(() => {
    void callUptade();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function callUptade() {
    try {
      const ordersDispachtRef = collection(db, "xpress_config");
      const docRefc = doc(ordersDispachtRef, "fromdConfig");
      const querySnapshot = await getDoc(docRefc);
      const totalDocuments = querySnapshot.data()?.totalDelivery ?? 0;
      setTotalDelivery(totalDocuments);

      const estimaet = totalDocuments * 0.0005;
      const clientsEstimate = totalDocuments * 0.85;
      setClientsEstimat(Math.round(clientsEstimate));
      setTotalCal(Math.round(estimaet + 26000));
    } catch (_) {
      /* silencioso */
    }
  }

  const features = [
    {
      img: btnvehicle,
      text: "Durante los plazos de entrega, usted y sus clientes pueden saber exactamente adónde va el paquete con nuestra tecnología de seguimiento en tiempo real.",
    },
    {
      img: btnuseradmin,
      text: "El reloj comienza a correr cuando crea la orden en nuestro sistema y uno de nuestros riders se ocupará de entregar el pedido en las manos de tu cliente.",
    },
    {
      img: btnacuerdo,
      text: "Potenciamos a nuestros clientes asegurando soluciones logísticas enfocadas en el objetivo correcto, con nuestro excelente servicio y la última tecnología.",
    },
  ];

  return (
    <div>
      <Grid2 celled="internally">
        {/* =========================
            HERO / Introducción
            ========================= */}
        <Box
          component={motion.section}
          variants={staggerContainer(0.14)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          sx={{
            display: { xs: "block", sm: "block", md: "flex", lg: "flex" },
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            px: 3,
            py: 4,
            maxWidth: "1200px",
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid2 item xs={12} md={6}>
            <Box component={motion.div} variants={slideRight}>
              <Typography
                variant="h3"
                fontWeight="bold"
                color="primary"
                sx={{ fontSize: { xs: "2rem", md: "3rem" } }}
              >
                BICCI
              </Typography>
              <Typography variant="h5" color="textSecondary">
                Última milla sustentable.
              </Typography>
              <Typography variant="body1" sx={{ mt: 2 }}>
                Somos BICCI, una Startup de última milla sustentable
                desarrollada para empresas. Ofrecemos un novedoso servicio de
                entrega a través de nuestros vehículos eléctricos, reduciendo la
                huella de carbono.
              </Typography>
            </Box>
          </Grid2>

          <Grid2 item xs={12} md={6}>
            <Box
              component={motion.img}
              variants={slideLeft}
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 180, damping: 16 }}
              src={homeImgUrl}
              alt="Bicci"
              sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }}
            />
          </Grid2>
        </Box>

        <div className="spacedivider" />

        {/* =========================
            Modalidades de envío
            ========================= */}
        <Box
          component={motion.section}
          variants={staggerContainer(0.12)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          sx={{
            backgroundColor: "#741AB0 ",
            color: "white",
            py: 4,
            textAlign: "center",
          }}
        >
          <Typography
            component={motion.h2}
            variants={fadeUp}
            variant="h4"
            fontWeight="bold"
            sx={{ color: "white" }}
          >
            Llega a más clientes con nuestras modalidades de envío
          </Typography>

          <Grid2 container spacing={3} justifyContent="center" sx={{ mt: 2 }}>
            {[
              {
                img: img1,
                title: "Quick Commerce",
                desc: "Entrega en menos de 30 minutos.",
              },
              {
                img: img11,
                title: "Servicio Express",
                desc: "Entrega en aproximadamente 3 horas.",
              },
              {
                img: img2,
                title: "Same Day",
                desc: "Entrega el mismo día antes de las 21h.",
              },
              {
                img: img3,
                title: "Next Day",
                desc: "Entrega programada para el día siguiente.",
              },
              {
                img: img4,
                title: "Logística Inversa",
                desc: "Servicio de devoluciones fácil y rápido.",
              },
            ].map((item, index) => (
              <Grid2 item xs={12} sm={6} md={4} lg={3} key={index}>
                <Card
                  component={motion.div}
                  variants={zoomIn}
                  whileHover={{
                    y: -4,
                    boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
                  }}
                  sx={{
                    maxWidth: 300,
                    mx: "auto",
                    minHeight: 400,
                    borderRadius: 3,
                  }}
                >
                  <CardActionArea>
                    <Box
                      component={motion.img}
                      whileHover={{ scale: 1.03 }}
                      transition={{
                        type: "spring",
                        stiffness: 160,
                        damping: 14,
                      }}
                      src={item.img}
                      alt={item.title}
                      sx={{
                        width: "100%",
                        minHeight: "280px",
                        borderRadius: 1,
                      }}
                    />
                    <CardContent>
                      <Typography variant="h6" fontWeight="bold">
                        {item.title}
                      </Typography>
                      <Typography variant="body2">{item.desc}</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Box>

        <div className="spacedivider" />

        {/* =========================
            Dashboard Bicci
            ========================= */}
        <Grid2
          component={motion.section}
          variants={staggerContainer(0.14)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          container
          spacing={4}
          alignItems="center"
          sx={{ px: 3, py: 6 }}
        >
          <Container
            maxWidth="md"
            sx={{
              mt: 4,
              mb: 4,
              display: { xs: "block", sm: "block", md: "flex", lg: "flex" },
            }}
          >
            <Grid2 item xs={12} md={6} sx={{ textAlign: "center" }}>
              <NavLink to="/eco-bicci">
                <Box
                  component={motion.img}
                  variants={slideRight}
                  whileHover={{ scale: 1.02 }}
                  src={biccidashboard}
                  alt="Dashboard Bicci"
                  sx={{
                    width: "100%",
                    maxWidth: 500,
                    height: "auto",
                    borderRadius: 2,
                    boxShadow: 3,
                  }}
                />
              </NavLink>
            </Grid2>

            <Grid2 container spacing={1} justifyContent="center" sx={{ mt: 2 }}>
              <Box
                component={motion.div}
                variants={fadeUp}
                xs={12}
                md={6}
                sx={{ p: 2 }}
              >
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  color="primary"
                  sx={{ fontSize: { xs: "2rem", md: "2.5rem" } }}
                >
                  Bicci Dashboard
                </Typography>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  sx={{ mt: 2 }}
                >
                  Accede a herramientas avanzadas para gestionar tus envíos,
                  monitorear entregas en tiempo real y optimizar la logística
                  con tecnología inteligente.
                </Typography>
              </Box>
            </Grid2>
          </Container>
        </Grid2>

        <div className="spacedivider" />

        {/* =========================
            Herramientas
            ========================= */}
        <Grid2 className="bannertiposdeservicio fondobicci">
          <Grid2
            component={motion.div}
            variants={staggerContainer(0.1)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
            computer={16}
            mobile={16}
            tablet={16}
          >
            <motion.div variants={fadeUp} className="colorWhite font-sizeBig">
              <h2 className="colorWhite">
                <strong>Herramientas para mejorar tu negocio</strong>
              </h2>
            </motion.div>

            <div className="cardHomeContent">
              {[
                // tres cards
                {
                  img: img12,
                  badge: "Próximamente",
                  title: "PUNTOS DE DESPACHO",
                  desc: "Genera tus órdenes con diferentes puntos despacho.",
                },
                {
                  img: img13,
                  badge: "",
                  title: "INTEGRACIONES",
                  desc: "Podemos integrarnos a tu plataforma y generar órdenes automáticas (previa evaluación).",
                },
                {
                  img: img14,
                  badge: "Nuevo",
                  title: "GESTIÓN DE RUTAS",
                  desc: "Organiza fechas y prioridades con rutas óptimas y eficientes.",
                },
              ].map((c, i) => (
                <Card
                  key={i}
                  component={motion.div}
                  variants={zoomIn}
                  whileHover={{ y: -6, rotate: 0.2 }}
                  transition={{ type: "spring", stiffness: 160, damping: 14 }}
                  className="cardHome3"
                  sx={{ maxWidth: 300, margin: 2, minWidth: 280 }}
                >
                  <CardActionArea>
                    {c.badge && (
                      <div className="services_badgeContainer">
                        <span className="services_badge">{c.badge}</span>
                      </div>
                    )}
                    <div className="services_header">
                      <span className="services_border"></span>
                      {c.title}
                    </div>
                    <img
                      src={c.img}
                      alt="bicci"
                      className="Home_cardContent3"
                    />
                    <CardContent>
                      <Typography
                        fontFamily="Lato, Arial, Helvetica, sans-serif"
                        variant="h6"
                        color="text.secondary"
                        className="min-heght"
                      >
                        {c.desc}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
            </div>
            <br />
          </Grid2>
        </Grid2>

        <div className="spacedivider" />
        <div className="spacedivider" />

        {/* =========================
            Beneficios Electromovilidad
            ========================= */}
        <Box
          component={motion.section}
          variants={staggerContainer(0.12)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          sx={{
            display: { xs: "block", sm: "block", md: "flex", lg: "flex" },
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            px: 3,
            py: 4,
            maxWidth: "1200px",
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid2 item xs={12} md={6}>
            <Box
              component={motion.img}
              variants={slideRight}
              whileHover={{ scale: 1.02 }}
              src={ecotribicci}
              alt="Electromovilidad"
              sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }}
            />
          </Grid2>
          <Grid2 item xs={12} md={6}>
            <Box component={motion.div} variants={fadeUp}>
              <Typography variant="h4" fontWeight="bold" color="primary">
                Beneficios de la Electromovilidad
              </Typography>
              <Typography variant="body1" sx={{ mt: 2 }}>
                Un vehículo eléctrico es CERO EMISIÓN, reduciendo la
                contaminación local y mejorando la calidad del aire.
              </Typography>
              <Typography variant="body1" sx={{ mt: 2 }}>
                La electromovilidad combate el cambio climático al usar
                electricidad en vez de combustibles fósiles.
              </Typography>
            </Box>
          </Grid2>
        </Box>

        {/* =========================
            Métricas
            ========================= */}
        <Box
          component={motion.section}
          variants={staggerContainer(0.08)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          sx={{
            backgroundColor: "#741AB0 ",
            color: "white",
            py: 6,
            textAlign: "center",
          }}
        >
          <Typography
            component={motion.h2}
            variants={fadeUp}
            variant="h4"
            fontWeight="bold"
            sx={{ color: "white" }}
          >
            Nuestros Logros
          </Typography>

          <Grid2 container spacing={3} justifyContent="center" sx={{ mt: 2 }}>
            {[
              {
                img: icomshome5,
                value: totalDelivery,
                label: "Productos entregados",
              },
              {
                img: icomshome3,
                value: clientsEstimat,
                label: "Clientes felices",
              },
              { img: icomshome2, value: 7, label: "Tiendas afiliadas" },
              {
                img: icomshome4,
                value: 36,
                label: "Tiendas usan nuestro shipping",
              },
              { img: icomshome1, value: totalCal, label: "CO2 Ahorrados (TH)" },
            ].map((item, index) => (
              <Grid2 key={index} item xs={12} sm={6} md={4} lg={2}>
                <Card
                  component={motion.div}
                  variants={zoomIn}
                  whileHover={{ y: -4 }}
                  sx={{ maxWidth: 250, mx: "auto", minHeight: 200 }}
                >
                  <CardActionArea>
                    <Box
                      component="img"
                      src={item.img}
                      alt={item.label}
                      sx={{ width: "100%", borderRadius: 1 }}
                    />
                    <CardContent>
                      <Typography variant="h5" fontWeight="bold">
                        <CountUp start={0} end={item.value} />
                      </Typography>
                      <Typography variant="body2">{item.label}</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Box>

        <div className="spacedivider" />

        {/* =========================
            Cobertura
            ========================= */}
        <Grid2 className="rowmarging">
          <Grid2 computer={16} mobile={16} tablet={16}>
            <div className="text-center">
              <br />
              <span className="abs-center">
                <h2 className="resaltadoCurvo subtilepage">
                  SOLICITAR COBERTURA.
                </h2>
              </span>
            </div>
          </Grid2>
        </Grid2>

        <Box
          component={motion.section}
          variants={staggerContainer(0.1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            px: 3,
            py: 4,
            maxWidth: "1200px",
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid2 className="rowmarging">
            <Grid2
              component={motion.div}
              variants={slideRight}
              computer={8}
              mobile={16}
              tablet={6}
            >
              <Box
                component="img"
                src={cobertura}
                alt=""
                sx={{ width: "100%", height: "auto" }}
              />
            </Grid2>

            <Grid2
              component={motion.div}
              variants={fadeUp}
              computer={8}
              mobile={16}
              tablet={6}
              id="paragraph2"
            >
              <div>
                <h2 className="resaltadoCurvo columnright">¿Porque Bicci?</h2>
                <h1 className="resaltado columnright">
                  Conviértete en un punto de recolección de paquetes
                </h1>
                <h3 className="columnright">
                  Genera ingresos extras desde tu local. Aumenta la circulación
                  de potenciales clientes en tu negocio, con la posibilidad de
                  aumentar tu ticket promedio de ventas.
                </h3>
                <div className="columnright">
                  <NavLink
                    className="btn btn-ebiex m-1"
                    to="/contacto"
                    aria-label="Incluir mi ubicación"
                  >
                    Incluir mi ubicación
                  </NavLink>
                </div>
              </div>
            </Grid2>
          </Grid2>
        </Box>

        {/* =========================
            ¿Por qué elegir a bicci?
            ========================= */}
        <Grid2 className="bannertiposdeservicio">
          <Grid2
            component={motion.div}
            variants={staggerContainer(0.1)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            computer={16}
            mobile={16}
            tablet={16}
          >
            <br />
            <motion.div variants={fadeUp} className="colorBlack font-sizeBig">
              <h2>
                <strong>¿Por qué elegir a bicci ?</strong>
              </h2>
            </motion.div>

            <div className="cardHomeContent">
              {[
                {
                  img: img16,
                  title: "ASESORÍA DE EXPERTOS",
                  desc: "Nos preocupamos por darte la mejor atención. Seguimiento durante todo el recorrido del producto hasta llegar a su destino final. Notificaciones según tus preferencias.",
                },
                {
                  img: img17,
                  title: "SERVICIOS DE ENCOMIENDAS Y MENSAJERÍAS",
                  desc: "Cotiza de forma simple y monitorea el status en tiempo real una vez iniciada la ruta.",
                },
                {
                  img: img15,
                  title: "¡QUEREMOS SER PARTE DE TU ÚLTIMA MILLA!",
                  desc: "Soluciones adaptadas a tus necesidades con una experiencia de usuario única. Reducimos huella de carbono con vehículos eco-sustentables.",
                },
                {
                  img: img18,
                  title: "SERVICIOS DE CALIDAD",
                  desc: "Portafolio que cubre necesidades de clientes en un ambiente amigable, transparente e innovador.",
                },
              ].map((c, i) => (
                <Card
                  key={i}
                  component={motion.div}
                  variants={zoomIn}
                  whileHover={{
                    y: -6,
                    boxShadow: "0 14px 36px rgba(0,0,0,0.25)",
                  }}
                  className="cardHome3"
                  sx={{ maxWidth: 300, margin: 2, minWidth: 280 }}
                >
                  <CardActionArea>
                    <div className="services_header">
                      <span className="services_border"></span>
                      {c.title}
                    </div>
                    <img
                      src={c.img}
                      alt="bicci"
                      className="Home_cardContent3"
                    />
                    <CardContent>
                      <Typography
                        fontFamily="Lato, Arial, Helvetica, sans-serif"
                        variant="body1"
                        color="text.secondary"
                        className="min-heght"
                      >
                        {c.desc}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
            </div>
            <br />
          </Grid2>
        </Grid2>

        {/* =========================
            Beneficios extra / texto largo
            ========================= */}
        <Box
          component={motion.section}
          variants={staggerContainer(0.12)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          sx={{
            display: { xs: "block", sm: "block", md: "flex", lg: "flex" },
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            px: 3,
            py: 4,
            maxWidth: "1200px",
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid2
            component={motion.div}
            variants={slideLeft}
            computer={8}
            mobile={16}
            tablet={6}
          >
            <Box
              component="img"
              src={ecotribicci2}
              alt=""
              sx={{ width: "100%", height: "auto" }}
            />
          </Grid2>
          <Grid2
            component={motion.div}
            variants={fadeUp}
            computer={8}
            mobile={16}
            tablet={6}
            id="paragraph2"
          >
            <div>
              <h2 className="resaltadoCurvo subtilepage">
                EVITA LA CONTAMINACIÓN ACÚSTICA:
              </h2>
              <p>
                Los vehículos eléctricos casi no emiten ruido; esto es clave en
                flotas numerosas, vehículos pesados o velocidades por sobre 50
                km/h.
              </p>
            </div>
            <br />
            <div>
              <h2 className="resaltadoCurvo subtilepage">
                GESTIÓN DE RESIDUOS RESPONSABLE:
              </h2>
              <p>
                No requieren lubricantes ni filtros, reduciendo residuos
                peligrosos. Frenos regenerativos disminuyen desgaste. Las
                baterías pueden reutilizarse en aplicaciones estacionarias y
                luego reciclarse.
              </p>
            </div>
            <br />
            <div>
              <h2 className="resaltadoCurvo subtilepage">
                BENEFICIOS DE LA ELECTROMOVILIDAD
              </h2>
              <p>
                Un EV usa cerca de 1/5 de la energía de un vehículo a combustión
                equivalente y puede recuperar energía con frenado regenerativo.
                Esto se traduce en eficiencia y ahorro operativo.
              </p>
            </div>
          </Grid2>
        </Box>

        <div className="spacedivider" />

        {/* =========================
            Más sobre Bicci (features gradient)
            ========================= */}
        <Grid2 className="rowmargingsmall">
          <Grid2 computer={16} mobile={16} tablet={16}>
            <div className="text-center">
              <br />
              <span className="abs-center">
                <h2 className="resaltadoCurvo subtilepage">MÁS SOBRE BICCI.</h2>
              </span>
            </div>
          </Grid2>
        </Grid2>
        <br />

        <Grid2 className="rowmarging">
          <Grid2 computer={8} mobile={16} tablet={6}>
            <Box
              component={motion.div}
              variants={staggerContainer(0.1)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
              spacing={3}
              justifyContent="center"
              sx={{
                display: { xs: "block", sm: "block", md: "flex", lg: "flex" },
              }}
            >
              {features.map((feature, index) => (
                <Card
                  key={index}
                  component={motion.div}
                  variants={zoomIn}
                  whileHover={{ y: -6 }}
                  sx={{
                    background:
                      "linear-gradient(to right bottom, #a4f6ff, #8df1fd, #72ecfc, #50e6fb, #00e1fb)",
                    boxShadow: 4,
                    borderRadius: 3,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    p: 2,
                    m: 1,
                  }}
                >
                  <Box
                    component="img"
                    src={feature.img}
                    alt=""
                    sx={{
                      width: "300px",
                      minWidth: "150px",
                      height: "auto",
                      mb: 1,
                    }}
                  />
                  <CardContent>
                    <Typography variant="body1" fontSize="1.1rem">
                      {feature.text}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Grid2>
        </Grid2>
      </Grid2>

      <Bannerfooter footermensaje={footermensaje} />
    </div>
  );
};

export default Pos5;
